import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import {ROUTE_PARTS} from "./index";
import PartsController from "../containers/PartsController";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_PARTS} component={PartsController}/>
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/PartRoutes.js